import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCloudNavContext } from '@lg-private/cloud-nav';

import { getHomeState, getSettingsState } from 'baas-ui/selectors';
import { RootState } from 'baas-ui/types';

const useCloudNavProjectSync = () => {
  const { setProject, isLoading, currentProject } = useCloudNavContext();
  const { groupId } = useSelector((state: RootState) => getHomeState(state));
  const { showCloudNav = true } = useSelector((state: RootState) => getSettingsState(state));

  useEffect(() => {
    if (showCloudNav && groupId && !isLoading && currentProject && currentProject.resourceId !== groupId) {
      setProject(groupId);
    }
  }, [showCloudNav, groupId, isLoading, currentProject, setProject]);
};

export default useCloudNavProjectSync;
